"use client";
import { Suspense, lazy } from "react";

// Lazy load wrapper component
export function LazyLoad({ children, fallback = null }) {
  return (
    <Suspense fallback={fallback}>
      {children}
    </Suspense>
  );
}

// Lazy load specific heavy components
export const LazyGlobe = lazy(() => import("@/components/magicui/globe").then(module => ({ default: module.Globe })));
export const LazyChatBot = lazy(() => import("@/components/ui/ChatBot"));
export const LazyFloatingDock = lazy(() => import("@/components/ui/floating-dock").then(module => ({ default: module.FloatingDock })));
export const LazyBackgroundBeams = lazy(() => import("@/components/ui/background-beams").then(module => ({ default: module.BackgroundBeams })));

// Loading fallbacks
export function GlobeFallback() {
  return (
    <div className="w-full aspect-square max-w-xl mx-auto bg-gradient-to-br from-blue-50 to-purple-50 dark:from-blue-950 dark:to-purple-950 rounded-full animate-pulse flex items-center justify-center">
      <div className="text-blue-600 dark:text-blue-400 text-lg">Loading Globe...</div>
    </div>
  );
}

export function ChatBotFallback() {
  return (
    <div className="fixed bottom-4 right-4 w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center shadow-lg animate-pulse">
      <div className="w-8 h-8 bg-white rounded-full"></div>
    </div>
  );
}

export function FloatingDockFallback() {
  return (
    <div className="mx-auto hidden h-64 items-end gap-6 rounded-2xl px-6 pb-5 md:flex">
      {[1, 2, 3, 4, 5].map((i) => (
        <div key={i} className="w-16 h-16 bg-gray-200 dark:bg-gray-700 rounded-full animate-pulse" />
      ))}
    </div>
  );
}

export function BackgroundBeamsFallback() {
  return (
    <div className="absolute inset-0 bg-gradient-to-br from-blue-50/50 to-purple-50/50 dark:from-blue-950/50 dark:to-purple-950/50" />
  );
} 